"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import Image from "next/image";
import { usePathname, useSearchParams } from "next/navigation";
import { useViewContext } from "./ViewContext";
import type { NavItem as NavItemData } from "./navTypes";
import { motion } from "framer-motion";
import { useAuth } from "../auth/Auth";
import { useTitle } from "@/contexts/TitleContext";
import { useUnreadNotifications } from "@/hooks/useUnreadNotifications";
import { useUnreadIndicator } from "@/hooks/useUnreadIndicator";
import { useNotificationsContext } from "../notifications/NotificationsContext";
import { isNavItemActive } from "./isNavItemActive";
import { useWaveData } from "@/hooks/useWaveData";
import { useWave } from "@/hooks/useWave";
import { getActiveWaveIdFromUrl } from "@/helpers/navigation.helpers";
interface Props {
  readonly item: NavItemData;
}
const NavItem = t0 => {
  const $ = _c(60);
  const {
    item
  } = t0;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    activeView,
    handleNavClick
  } = useViewContext();
  const {
    name
  } = item;
  const {
    icon
  } = item;
  const isLogoItem = name === "Home";
  let t1;
  if ($[0] !== pathname || $[1] !== searchParams) {
    t1 = getActiveWaveIdFromUrl({
      pathname,
      searchParams
    });
    $[0] = pathname;
    $[1] = searchParams;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const waveIdFromQuery = t1;
  let t2;
  if ($[3] !== waveIdFromQuery) {
    t2 = {
      waveId: waveIdFromQuery,
      onWaveNotFound: _temp
    };
    $[3] = waveIdFromQuery;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: waveData
  } = useWaveData(t2);
  const {
    isDm: isCurrentWaveDmValue
  } = useWave(waveData);
  const {
    connectedProfile
  } = useAuth();
  const {
    setTitle
  } = useTitle();
  const {
    notifications,
    haveUnreadNotifications
  } = useUnreadNotifications(item.name === "Notifications" ? connectedProfile?.handle ?? null : null);
  const t3 = item.name === "Messages" ? connectedProfile?.handle ?? null : null;
  let t4;
  if ($[5] !== t3) {
    t4 = {
      type: "messages",
      handle: t3
    };
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    hasUnread: hasUnreadMessages
  } = useUnreadIndicator(t4);
  const {
    removeAllDeliveredNotifications
  } = useNotificationsContext();
  let t5;
  if ($[7] !== haveUnreadNotifications || $[8] !== item.name || $[9] !== notifications?.unread_count || $[10] !== removeAllDeliveredNotifications || $[11] !== setTitle) {
    t5 = () => {
      if (item.name !== "Notifications") {
        return;
      }
      setTitle(haveUnreadNotifications ? `(${notifications?.unread_count}) Notifications | 6529.io` : "6529.io");
      if (!haveUnreadNotifications) {
        removeAllDeliveredNotifications();
      }
    };
    $[7] = haveUnreadNotifications;
    $[8] = item.name;
    $[9] = notifications?.unread_count;
    $[10] = removeAllDeliveredNotifications;
    $[11] = setTitle;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = notifications?.unread_count;
  let t7;
  if ($[13] !== haveUnreadNotifications || $[14] !== t6) {
    t7 = [haveUnreadNotifications, t6];
    $[13] = haveUnreadNotifications;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  useEffect(t5, t7);
  if (item.disabled) {
    let t8;
    if ($[16] !== icon || $[17] !== item.iconComponent || $[18] !== item.iconSizeClass || $[19] !== name) {
      t8 = <div className="tw-flex tw-items-center tw-justify-center">{item.iconComponent ? <item.iconComponent className={`${item.iconSizeClass ?? "tw-size-7"} tw-text-iron-500`} /> : <Image src={icon} alt={name} width={24} height={24} unoptimized={true} className={item.iconSizeClass ?? "tw-size-7"} />}</div>;
      $[16] = icon;
      $[17] = item.iconComponent;
      $[18] = item.iconSizeClass;
      $[19] = name;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    let t9;
    if ($[21] !== name || $[22] !== t8) {
      t9 = <button type="button" aria-label={name} aria-disabled="true" disabled={true} className="tw-pointer-events-none tw-relative tw-flex tw-h-16 tw-w-full tw-min-w-0 tw-flex-col tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-opacity-40 tw-transition-colors focus:tw-outline-none">{t8}</button>;
      $[21] = name;
      $[22] = t8;
      $[23] = t9;
    } else {
      t9 = $[23];
    }
    return t9;
  }
  const iconSizeClass = item.iconSizeClass ?? "tw-size-7";
  const t8 = pathname ?? "";
  let t9;
  if ($[24] !== searchParams) {
    t9 = searchParams ?? new URLSearchParams();
    $[24] = searchParams;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== activeView || $[27] !== isCurrentWaveDmValue || $[28] !== item || $[29] !== t8 || $[30] !== t9) {
    t10 = isNavItemActive(item, t8, t9, activeView, isCurrentWaveDmValue);
    $[26] = activeView;
    $[27] = isCurrentWaveDmValue;
    $[28] = item;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  const isActive = t10;
  const t11 = isActive ? "page" : undefined;
  let t12;
  if ($[32] !== handleNavClick || $[33] !== item) {
    t12 = () => handleNavClick(item);
    $[32] = handleNavClick;
    $[33] = item;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== isActive || $[36] !== isLogoItem) {
    t13 = isActive && <motion.div layoutId="nav-indicator" className={`tw-absolute tw-left-0 tw-top-0 tw-h-0.5 tw-w-full tw-rounded-full tw-bg-white ${isLogoItem ? "tw-top-1" : ""}`} />;
    $[35] = isActive;
    $[36] = isLogoItem;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== icon || $[39] !== iconSizeClass || $[40] !== isActive || $[41] !== item.iconComponent || $[42] !== name) {
    t14 = item.iconComponent ? <item.iconComponent className={`${iconSizeClass} ${isActive ? "tw-text-white" : "tw-text-iron-500"}`} /> : <Image src={icon} alt={name} width={24} height={24} unoptimized={true} className={iconSizeClass} />;
    $[38] = icon;
    $[39] = iconSizeClass;
    $[40] = isActive;
    $[41] = item.iconComponent;
    $[42] = name;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  let t15;
  if ($[44] !== haveUnreadNotifications || $[45] !== item.name) {
    t15 = item.name === "Notifications" && haveUnreadNotifications && <div className="tw-absolute -tw-right-1 -tw-top-1 tw-h-2.5 tw-w-2.5 tw-rounded-full tw-bg-red" />;
    $[44] = haveUnreadNotifications;
    $[45] = item.name;
    $[46] = t15;
  } else {
    t15 = $[46];
  }
  let t16;
  if ($[47] !== hasUnreadMessages || $[48] !== item.name) {
    t16 = item.name === "Messages" && hasUnreadMessages && <div className="tw-absolute -tw-right-1 -tw-top-1 tw-h-2.5 tw-w-2.5 tw-rounded-full tw-bg-red" />;
    $[47] = hasUnreadMessages;
    $[48] = item.name;
    $[49] = t16;
  } else {
    t16 = $[49];
  }
  let t17;
  if ($[50] !== t14 || $[51] !== t15 || $[52] !== t16) {
    t17 = <div className="tw-relative tw-flex tw-items-center tw-justify-center">{t14}{t15}{t16}</div>;
    $[50] = t14;
    $[51] = t15;
    $[52] = t16;
    $[53] = t17;
  } else {
    t17 = $[53];
  }
  let t18;
  if ($[54] !== name || $[55] !== t11 || $[56] !== t12 || $[57] !== t13 || $[58] !== t17) {
    t18 = <button type="button" aria-label={name} aria-current={t11} onClick={t12} className="tw-relative tw-flex tw-h-16 tw-w-full tw-min-w-0 tw-flex-col tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-transition-colors focus:tw-outline-none">{t13}{t17}</button>;
    $[54] = name;
    $[55] = t11;
    $[56] = t12;
    $[57] = t13;
    $[58] = t17;
    $[59] = t18;
  } else {
    t18 = $[59];
  }
  return t18;
};
export default NavItem;
function _temp() {}